<div class="center">
    <p class="p1 p-t-6 center">
        <span class="inline-block p-b">{{'Displaying reviews' | translate}}</span>&nbsp;
        <span>{{(pageSize * page) > total ? (total | number) : ((pageSize * page) | number)}}</span>/{{total | number}}
    </p>

    <!-- first page -->
    <button class="m-r-1"
            [class.disabled]="page <= 1"
            type="button"
            [attr.aria-label]="'First page' | translate"
            (click)="first()">
        <span>|</span>
        <i class="icon-chevron-left fs-5"
           aria-hidden="true"></i>
    </button>

    <!-- prev page -->
    <button [class.disabled]="page <= 1"
            type="button"
            [attr.aria-label]="'Previous page' | translate"
            (click)="prev()">
        <i class="icon-chevron-left fs-5"
           aria-hidden="true"></i>
    </button>

    <!-- nav -->
    @for (pageNumber of pages; track $index) {
    <span class="p1 cursor-pointer m-l-3 m-r-3"
          [ngClass]="{'underline': pageNumber == page}"
          (click)="pick(pageNumber)">{{pageNumber}}</span>
    }

    <!-- next page -->
    <button class="m-l-1"
            [class.disabled]="page >= pagesCount"
            type="button"
            [attr.aria-label]="'Next page' | translate"
            (click)="next()">
        <i class="icon-chevron-right fs-5"
           aria-hidden="true"></i>
    </button>

    <!-- last page -->
    <button class="m-l-1"
            [class.disabled]="page >= pagesCount"
            type="button"
            [attr.aria-label]="'Last page' | translate"
            (click)="last()">
        <i class="icon-chevron-right fs-5"
           aria-hidden="true"></i>
        <span>|</span>
    </button>
</div>
